import CreateAccount from './CreateAccount';
import './CreateAccount.scss';

export default CreateAccount;
